import React from 'react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { InfoTooltip } from 'src/App/HOC/Tooltips';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { INFO_BUTTON_COLOR } from 'src/colors';

const InfoButton = ({ tooltipContent }: { tooltipContent: ReactJSXElement }) => {
  return (
    <InfoTooltip title={tooltipContent}>
      <InfoOutlined sx={{ fontSize: 16, color: INFO_BUTTON_COLOR }} />
    </InfoTooltip>
  );
};

export default InfoButton;
